import { GetUserModelResponseProto } from "@noom/noom-contracts/noom_contracts/usermodel/service/v3/user_model_service";
import { Api } from "@noom/noomscape";
import axios from "axios";

Api.register(
  "userModel.getUserModel",
  async ({
    accessCode,
    accessToken,
    fieldMask,
  }: {
    accessCode: string;
    accessToken: string;
    fieldMask?: string;
  }) => {
    const response = await axios({
      baseURL: window.ENV.SERVER_URL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: "GET",
      params: fieldMask ? { fieldMask } : undefined,
      url: `/userModel/v3/users/${accessCode}/userModel`,
      urlWithPathParams: "/userModel/v3/users/{accessCode}/userModel",
    });

    return response.data as GetUserModelResponseProto;
  },
);
